<ng-container *ngIf="inPostPage; else CurrentlyReadingTemplate">
  <section class="w-full flex flex-wrap">
    <!-- ? User Latest Posts -->
    <div class="w-full flex flex-wrap border-b border-gray-100 dark:border-gray-600">
      <p class="text-gray-600 text-base font-medium mb-4">
        پست‌های اخیر این کاربر
      </p>
      <ng-container *ngIf="!gettingPostData; else skeletonLeftPosts">
        <ng-container *ngFor="let post of guestPosts">
          <app-post-suggeste-item class="w-full mb-4" [Post]="post"></app-post-suggeste-item>
        </ng-container>
      </ng-container>
    </div>

    <!-- ? Suggested Posts -->
    <div class="w-full mt-4 flex flex-wrap border-b border-gray-100 dark:border-gray-600">
      <p class="text-gray-600 text-base font-medium mb-4">پست‌های پیشنهادی</p>
      <ng-container *ngIf="!gettingPostData; else skeletonLeftPosts">
        <ng-container *ngFor="let post of suggestedPosts">
          <app-post-suggeste-item class="w-full mb-4" [Post]="post"></app-post-suggeste-item>
        </ng-container>
      </ng-container>
    </div>
  </section>
</ng-container>

<ng-template #CurrentlyReadingTemplate>
  <section class="w-full flex flex-wrap">
    <!-- ? Show Books  -->
    <ng-container *ngIf="!loading && _localRepository.IsInBrowser; else skeletonTemplate">
      <ng-container *ngIf="books && books?.length > 0; else emptyTemplate">
        <div class="w-full flex flex-wrap">
          <!-- ? Header -->
          <div class="w-full flex flex-wrap justify-between items-center">
            <div class="w-6/12 md:w-8/12 flex items-center">
              <span class="text-base font-medium text-gray-900">در حال خواندن
                <a [routerLink]="[routes.library_book, currentUser?.id]" [queryParams]="{
                    bookState: 2,
                    shelfName: 'CurrentlyReading',
                    shelfOwner: currentUser?.uniqeName
                  }">
                  <span class="text-sm bg-gray-50 dark:bg-gray-800 text-gray-500 px-2 rounded-md">{{ allBooksCount
                    }}</span>
                </a>
              </span>
            </div>
          </div>

          <div class="w-full mt-4">
            <div class="w-full flex book-item p-2 mb-4 rounded-md bg-gray-50 dark:bg-gray-800"
              *ngFor="let book of books; trackBy: trackBooks" (click)="close(book)">
              <!-- ? Book Image -->
              <img loading="lazy" class="w-16 min-w-16 h-24 rounded-lg cursor-pointer object-cover" width="64"
                height="96" onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_book.svg'"
                [src]="book?.id | image : imageType.book : book?.hasPhoto" [alt]="book?.name" />

              <!-- ? Book Info and Progress -->
              <div class="grow flex flex-wrap pr-2">
                <!-- ? Book Name and progress btn -->
                <div class="w-full flex flex-wrap items-center">
                  <!--? Book Name  -->
                  <p class="text-gray-900 text-base font-medium cursor-pointer line-clamp-1" *ngIf="book?.name">
                    {{ book?.name }}
                  </p>
                </div>

                <!-- ? book author name -->
                <div class="w-full">
                  <p class="text-sm cursor-pointer text-gray-700" *ngFor="
                      let author of book.authors | authorSort | slice : 0 : 1
                    ">
                    {{ (author | authorType).name }}
                  </p>
                </div>

                <!-- ? Proggress -->
                <app-progress-bar [totalCount]="book?.pageCount" [unitCount]="book?.steps?.steps"></app-progress-bar>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </section>
</ng-template>

<ng-template #emptyTemplate>
  <!-- ? Empty  -->
  <section class="w-full flex flex-wrap">
    <div class="w-full justify-between">
      <span class="text-base text-gray-800">در حال خواندن</span>
    </div>

    <div class="w-full">
      <div class="empty-shelf mb-4"></div>
      <p class="text-base text-gray-900 text-center">
        کتاب در حال خواندنی وجود ندارد.
      </p>

      <p class="text-sm text-gray-700 text-center mt-4">
        با جست‌و‌جو در سایت می‌توانید کتاب‌های مورد نظرتان را به این قفسه اضافه
        کنید.
      </p>
    </div>
  </section>
</ng-template>

<ng-template #skeletonTemplate>
  <div class="w-full flex flex-wrap">
    <div class="w-full mt-4">
      <div class="w-full flex">
        <ngx-skeleton-loader class="flex book-md" [theme]="{ height: '100%', width: '100%' }">
        </ngx-skeleton-loader>

        <div class="grow pr-4 flex flex-wrap">
          <div class="w-full flex items-center justify-between">
            <ngx-skeleton-loader class="flex" [theme]="{ height: '16px', width: '60px' }">
            </ngx-skeleton-loader>
          </div>
          <div class="w-full flex">
            <ngx-skeleton-loader class="flex w-full" [theme]="{ height: '14px', width: '70%' }">
            </ngx-skeleton-loader>
          </div>
          <div class="w-full flex items-center justify-between">
            <ngx-skeleton-loader class="flex" [theme]="{ height: '14px', width: '30px' }">
            </ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- ? Left side Posts skeleton -->
<ng-template #skeletonLeftPosts>
  <ng-container *ngFor="let item of [0, 1, 2]">
    <div class="flex flex-wrap w-full mb-4">
      <!-- ? Actor -->
      <div class="w-full flex flex-wrap items-center">
        <ngx-skeleton-loader class="flex" [appearance]="'circle'"></ngx-skeleton-loader>
        <ngx-skeleton-loader class="flex mr-1" [theme]="{ height: '14px', width: '100px' }">
        </ngx-skeleton-loader>
      </div>
      <!-- ? Post Image -->
      <div class="w-full flex flex-wrap mt-2 justify-center">
        <ngx-skeleton-loader class="flex w-full h-[140px]"
          [theme]="{ height: '100%', width: '100%', borderRadius: '12px' }">
        </ngx-skeleton-loader>
      </div>
    </div>
  </ng-container>
</ng-template>